import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { EmailMessagesAPI } from 'api/email-messages';
import { EmailMessage } from 'api/email-messages/types';

const EMAIL_MESSAGES_QUERY_KEY = (sourceId: number) =>
  ['email-messages', sourceId] as const;

const EMAIL_SUMMARY_QUERY_KEY = (sourceId: number) =>
  ['email-messages', 'summary', sourceId] as const;

export const useEmailMessagesQuery = (
  sourceId: number | undefined,
): UseQueryResult<EmailMessage[], Error> => {
  return useQuery({
    queryKey: EMAIL_MESSAGES_QUERY_KEY(sourceId ?? -1),
    queryFn: () => EmailMessagesAPI.getMessages(sourceId as number),
    enabled: sourceId != null && sourceId > 0,
  });
};

export const useEmailSummaryQuery = (
  sourceId: number | undefined,
): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: EMAIL_SUMMARY_QUERY_KEY(sourceId ?? -1),
    queryFn: () => EmailMessagesAPI.getSummary(sourceId as number),
    enabled: sourceId != null && sourceId > 0,
  });
};
